// The Shiny session token, pushed from the server on the "beamm:session"
// custom-message channel (see app/view/pages/simulation.R) and attached as the
// X-Beamm-Session header on Plumber engine-API requests (see lib/api.ts).
//
// It's the join key that lets the engine API's request logs correlate with the
// Shiny session that drove them (#194). Held as a plain module-level value, not
// React state — api.ts is a plain async function, not a component, and reads it
// directly. Null until the server's push arrives shortly after mount, so the
// very first request (the mount-time baseline fetch) may go without it; every
// request after the token lands carries it.

let sessionToken: string | null = null;

export function setSessionToken(token: string): void {
  sessionToken = token;
}

export function getSessionToken(): string | null {
  return sessionToken;
}
